import { Component } from 'react';
import { Field } from 'redux-form';

import { TextArea, CheckBox } from 'common/components/forms';

class ShippingInstructions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShippingInstructions:
        (props.cart && props.cart.shippingInstructions) || false
    };
  }

  handleShippingInstructionsChange = (e) => {
    this.setState({ isShippingInstructions: e.target.checked });
  };

  render() {
    const { isShippingInstructions } = this.state;
    return (
      <>
        <Field
          name="isShippingInstructions"
          type="checkbox"
          component={CheckBox}
          onChange={this.handleShippingInstructionsChange}
          value="1"
          label="Add shipping instructions"
        />
        {isShippingInstructions && (
          <Field
            name="shippingInstructions"
            component={TextArea}
            label="Shipping instructions"
            rows={5}
          />
        )}
      </>
    );
  }
}

export default ShippingInstructions;
